import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import moment from 'moment';
import { SupplierSyncEvent } from '@dill/dill-shared';

import { AppServerResponse } from '../../utils/interfaces/generalInterfaces';
import { SyncHistoryInitialState } from '../globalSlices/syncHistorySlice';
import { getSupplierSyncHistory } from '../services/syncHistoryService';

export const getSupplierSyncHistoryExtraReducer = (
  builder: ActionReducerMapBuilder<SyncHistoryInitialState>
) => {
  const reducerId = 'getSupplierSyncHistory';
  builder.addCase(getSupplierSyncHistory.pending, (state) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(getSupplierSyncHistory.fulfilled, (state, action) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    const payload = action.payload as AppServerResponse | null;
    if (payload && payload.success && payload?.data) {
      const syncEvents: SupplierSyncEvent[] = payload.data;
      state.syncEvents = syncEvents;
      // browsing an older range must not change the dot next to "Synced X ago"
      const { endDate } = action.meta.arg;
      if (!endDate || moment(endDate).isSameOrAfter(moment().subtract(1, 'minute'))) {
        state.latestSyncStatus =
          syncEvents.find((event) => event.status !== 'RUNNING')?.status ?? null;
      }
    }
  });
  builder.addCase(getSupplierSyncHistory.rejected, (state) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
